import { render, staticRenderFns } from "./LearningUnitHeader.vue?vue&type=template&id=454b25d9&"
import script from "./LearningUnitHeader.vue?vue&type=script&lang=js&"
export * from "./LearningUnitHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports